import { MatDialog } from '@angular/material/dialog'

import { VirheDialog, VirheDialogData } from '../_components/virhe.dialog'

import { Overlay, OverlayRef } from '@angular/cdk/overlay'
import { ComponentPortal } from '@angular/cdk/portal'
import { Injectable } from '@angular/core'
import { LoadingContentComponent } from '../_components/loading-content.component'

@Injectable()
export class LadataanService {
  private _overlayRef: OverlayRef = null

  constructor(
    private _overlay: Overlay,
    private _dialog: MatDialog,
  ) {
    _dialog.afterOpened.subscribe(() => {
      if (this._overlayRef) {
        this.lopetaLataaminen()
        this.aloitaLataaminen()
      }
    })
  }

  aloitaLataaminen() {
    if (!this._overlayRef) {
      this._overlayRef = this._overlay.create({
        hasBackdrop: true,
        scrollStrategy: this._overlay.scrollStrategies.block(),
        positionStrategy: this._overlay.position().global().centerHorizontally().centerVertically(),
        maxHeight: '100vh',
        maxWidth: '100vw',
        minHeight: '100vh',
        minWidth: '100vw',
      })
      this._overlayRef.attach(new ComponentPortal(LoadingContentComponent))
    }
  }

  lopetaLataaminen() {
    if (this._overlayRef) {
      this._overlayRef.detach()
      this._overlayRef.dispose()
      this._overlayRef = null
    }
  }

  naytaVirheDialog(error: Error | null): void {
    const data: VirheDialogData = {
      error: error,
    }
    this._dialog.open(VirheDialog, { data: data })
  }
}
